

/* tslint:disable */




import { FlowchartComponentDto } from './FlowchartComponentDto';
import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineActionDto } from './GuidelineActionDto';

export class FlowchartSubflowDto extends FlowchartComponentDto {
    guidelineActionId?: string;
    guidelineAction?: GuidelineActionDto;
    elementType?: FlowchartElementType;

}

